import _ from 'lodash'
import { ICoordinate } from "@/api/types"

export interface IJdWorkCompany {
    name: string
    id: number
    coord: ICoordinate
}

const Companies: IJdWorkCompany[] = [
    {
        name: 'Micron Plant A',
        id: 164,
        coord: {
            abscissa: 103.864616,
            ordinate: 1.318369,
        }
    },
    {
        name: 'Micron Plant B',
        id: 165,
        coord: {
            abscissa: 103.793171,
            ordinate: 1.453619,
        }
    },
    {
        name: 'Micron Plant C',
        id: 166,
        coord: {
            abscissa: 103.76708367446876,
            ordinate: 1.4314535967056397,
        }
    },
    {
        name: 'JD',
        id: 85,
        coord: {
            abscissa: 103.6970044642102,
            ordinate: 1.3159362004601007,
        }
    },
]

export const JDWorks = {
    CompanyId: 13,
    Companies
}

export function isJDWork(store) {
    return _.get(store, 'getters.currentParentCompany') === JDWorks.CompanyId
}
